import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Home.vue'),
    meta: {
      title: "AZORult Tracker"
    }
  },
  {
    path: '/s/:type/:query',
    name: 'search',
    component: () => import('../views/Home.vue'),
    meta: {
      title: "Search | AZORult Tracker"
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/About.vue'),
    meta: {
      title: "About | AZORult Tracker"
    }
  },
  {
    path: '/doc',
    name: 'api',
    component: () => import('../views/API.vue'),
    meta: {
      title: "API | AZORult Tracker"
    }
  },
  {
    path: '/panel/:id',
    name: 'panel',
    component: () => import('../views/Details.vue'),
    meta: {
      title: "Details | AZORult Tracker"
    }
  },
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
